import { render, staticRenderFns } from "./ClassifyNav.vue?vue&type=template&id=616ed23d&scoped=true"
import script from "./ClassifyNav.vue?vue&type=script&lang=js"
export * from "./ClassifyNav.vue?vue&type=script&lang=js"
import style0 from "./ClassifyNav.vue?vue&type=style&index=0&id=616ed23d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616ed23d",
  null
  
)

export default component.exports